import { Button, Upload, message } from 'antd';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { AddFileIcon } from '../../../resource/icons';
import appSettings from '../../../constants/app.constants';
import { authUploadHeader } from '../../../helpers/auth-header';
import styles from './AttachmentButton.module.scss';

const AttachmentButton = ({
  postUrl,
  getAttachmentsList,
  multiple = true,
  acceptFormats = [],
}) => {
  const [fileList, setFileList] = useState([]);

  const beforeUpload = useCallback((file) => {
    setFileList((fileList) => [...fileList, file]);
    if (file.size > 15728640) {
      message.error('Файл должен весить не больше 15 мб');
      return false;
    }
    if (
      Array.isArray(acceptFormats) &&
      acceptFormats.length &&
      !acceptFormats.some((format) =>
        file.name
          .toLowerCase()
          .endsWith(
            format.startsWith('.')
              ? format.toLowerCase()
              : `.${format.toLowerCase()}`
          )
      )
    ) {
      message.error(`Файлы данного формата не принимаются в систему`);
      return false;
    }
    return true;
  }, []);
  const onFileUploaded = useCallback(async () => {
    await getAttachmentsList('update');
    setFileList([]);
  }, [getAttachmentsList]);
  const authHeader = useMemo(authUploadHeader);

  const accept = useMemo(() => {
    if (!acceptFormats?.length) {
      return undefined;
    }
    return acceptFormats
      .map((format) => (format.startsWith('.') ? format : `.${format}`))
      .join(',');
  }, [acceptFormats]);

  return (
    <Upload
      className={styles.upload}
      name={'file'}
      showUploadList={false}
      multiple={multiple}
      beforeUpload={beforeUpload}
      fileList={fileList}
      headers={authHeader}
      action={appSettings.apiUrl + postUrl}
      onSuccess={onFileUploaded}
      accept={accept}
    >
      <Button className={styles.addFileButton}>
        <AddFileIcon />
        <span className={styles.buttonText}>Прикрепить файл</span>
      </Button>
    </Upload>
  );
};

export default memo(AttachmentButton);
